/* eslint-disable camelcase */
import React from 'react';
import { ColorBatch } from 'components';
import { dateFormat, reportStatusColorMap, reportStatusName } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var commissionsHistoryColumns = [{
  name: 'Име',
  value: 'franchisee.name',
  flex: '1 0 160px'
}, {
  name: 'Заявяване на',
  value: 'request_date',
  dateTimeFormat: dateFormat,
  width: '130px'
}, {
  name: 'Плащане на',
  value: 'sent_date',
  dateTimeFormat: dateFormat,
  width: '130px'
}, {
  name: 'Потвърждение на',
  value: 'confirmation_date',
  dateTimeFormat: dateFormat,
  width: '140px'
}, {
  name: 'Отхвърлен на',
  value: 'rejected_date',
  dateTimeFormat: dateFormat,
  width: '130px'
}, {
  name: 'База',
  render: function render(_ref) {
    var base_amount = _ref.base_amount,
        currency = _ref.currency;
    return ___EmotionJSX("span", null, base_amount, " ", currency);
  },
  width: '140px'
}, {
  name: 'Комисиона',
  render: function render(_ref2) {
    var commission_amount = _ref2.commission_amount,
        currency = _ref2.currency;
    return ___EmotionJSX("span", null, commission_amount, " ", currency);
  },
  width: '140px'
}, {
  name: 'Статус',
  render: function render(_ref3) {
    var status = _ref3.status;
    return ___EmotionJSX(ColorBatch, {
      type: reportStatusColorMap[status]
    }, reportStatusName[status]);
  },
  width: '130px'
}];